import {updateFactory} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {aUserFeedBackSubmitSuccessful} from '@modifi/plugin-onboarding'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import {getLogger} from '../../../../../utils'
import {aFetchIntermediaryShareholders} from '../../../../../data/intermediary-shareholders'
import {aFetchInputFields} from '../../../../../data/input-fields'
import {ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID} from '../../../../../routes/constants'
import {SECTION_INTERMEDIARY_SHAREHOLDERS} from '../../../../../constants/sections'

const apiClient = getAuthenticatedThemisClient()

const logger = getLogger('intermediary-shareholder-page')

const {reducer, actions, selectors} = updateFactory({
  rootSelector: state => state?.pages?.intermediaryShareholderConfirmation,
  actionNamePrefix: 'pages/intermediary-shareholder/form',
  submitRequest:
    (a, body: Record<string, any>, forceCreate?: boolean) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      let createdIntermediaryShareholderCompanyExternalId = ''
      try {
        logger.info(
          `${
            forceCreate
              ? 'Creating company with user data and not using existing'
              : 'Linking already existing company'
          }`,
          body
        )
        const saveResponse = await apiClient.ShareholdingCompanies.create({
          body,
          forceCreate,
        }).then(res => res.data())
        createdIntermediaryShareholderCompanyExternalId = saveResponse?.externalId
      } catch (error: any) {
        logger.error('Error while creating or updating a person: %o', error)
        dispatch(a.errorAction(error))
        return
      }
      await Promise.all([dispatch(aFetchInputFields()), dispatch(aFetchIntermediaryShareholders())])
      dispatch(aCloseDialog())
      // redirect to newly created shareholder owner
      dispatch(
        aPush(
          generatePath(ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID, {
            externalId: createdIntermediaryShareholderCompanyExternalId,
          })
        )
      )

      dispatch(a.successAction())
      dispatch(aUserFeedBackSubmitSuccessful(SECTION_INTERMEDIARY_SHAREHOLDERS))
    },

  reset:
    a =>
    (dispatch): void => {
      dispatch(a.clearAction())
    },
})

export default reducer

export const {
  selectUpdatePending: selectSavePending,

  selectUpdateErrorMessage: selectSaveErrorMessage,
} = selectors

export const {aReset, aSubmit: aSaveDataFromConfirmation} = actions
